var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"10","lg":"8"}},[_c('h1',[_vm._v("Edit Calendar")]),_c('b-card',[_c('calendar-form',{ref:"calendar"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }